(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["db-banner-carousel"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.db-banner-carousel').forEach(function (section) {

    const slides = section.querySelectorAll('.db-banner-carousel__slide');
    const dots = section.querySelectorAll('.db-banner-carousel__dot');
    const prevBtn = section.querySelector('.db-banner-carousel__nav--prev');
    const nextBtn = section.querySelector('.db-banner-carousel__nav--next');

    if (!slides.length) return;

    let index = 0;
    const autoplay = section.dataset.autoplay === 'true';
    const interval = parseInt(section.dataset.interval, 10) || 5000;
    let timer;

    function getVisibleMedia(slide) {
      if (window.innerWidth <= 700) {
        return slide.querySelector('.db-mobile-video, .db-mobile');
      }
      return slide.querySelector('.db-desktop-video, .db-desktop, .db-banner-carousel__image');
    }

    function getVisibleVideo(slide) {
      if (window.innerWidth <= 700) {
        return slide.querySelector('.db-mobile-video');
      }
      return slide.querySelector('.db-desktop-video');
    }

    function pauseAllVideos() {
      section.querySelectorAll('video').forEach((video) => {
        video.pause();
      });
    }

    function setHeight() {
      const activeSlide = slides[index];
      const media = getVisibleMedia(activeSlide);

      if (!media) return;

      const applyHeight = () => {
        section.style.height = activeSlide.offsetHeight + 'px';
      };

      if (media.tagName === 'VIDEO') {
        if (media.readyState >= 1) {
          applyHeight();
        } else {
          media.addEventListener('loadedmetadata', applyHeight, { once: true });
        }
      } else if (media.tagName === 'IMG') {
        if (media.complete) {
          applyHeight();
        } else {
          media.onload = applyHeight;
        }
      } else {
        applyHeight();
      }
    }

    function goToSlide(i) {
      index = (i + slides.length) % slides.length;

      pauseAllVideos();

      slides.forEach((slide, s) => {
        slide.classList.toggle('is-active', s === index);
      });

      dots.forEach((dot, d) => {
        dot.classList.toggle('active', d === index);
      });

      const activeVideo = getVisibleVideo(slides[index]);
      if (activeVideo) {
        activeVideo.play().catch(() => {});
      }

      setHeight();
    }

    function startAutoplay() {
      if (!autoplay || slides.length < 2) return;
      stopAutoplay();
      timer = setInterval(() => goToSlide(index + 1), interval);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        goToSlide(i);
        startAutoplay();
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        goToSlide(index - 1);
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        goToSlide(index + 1);
        startAutoplay();
      });
    }

    window.addEventListener('resize', () => {
      goToSlide(index);
    });

    section.querySelectorAll('.db-desktop-video').forEach((video) => {
      const wrapper = video.closest('.db-video-wrapper');

      video.addEventListener('loadeddata', () => {
        wrapper.classList.add('db-video-ready-desktop');
        setHeight();
      });

      if (video.readyState >= 2) {
        wrapper.classList.add('db-video-ready-desktop');
      }
    });

    section.querySelectorAll('.db-mobile-video').forEach((video) => {
      const wrapper = video.closest('.db-video-wrapper');

      video.addEventListener('loadeddata', () => {
        wrapper.classList.add('db-video-ready-mobile');
        setHeight();
      });

      if (video.readyState >= 2) {
        wrapper.classList.add('db-video-ready-mobile');
      }
    });

    slides[0].classList.add('is-active');
    goToSlide(0);
    startAutoplay();
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
